import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
//import { LocalizedString } from '../course/localized-string'
import { RestApiService } from './rest-api.service';



@Injectable()
export class TextService {

  endpoint = 'text';

  constructor(private api: RestApiService) { }



  getText(key: string): Observable<any> {
    return this.api.getOne(this.endpoint, key);
  }



}
